import { render, staticRenderFns } from "./BasePill.vue?vue&type=template&id=75fee53c"
import script from "./BasePill.vue?vue&type=script&lang=js"
export * from "./BasePill.vue?vue&type=script&lang=js"
import style0 from "./BasePill.vue?vue&type=style&index=0&id=75fee53c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports